import { TrashIcon as PhosphorTrashIcon, type IconProps } from "@phosphor-icons/react";

export function TrashIcon(props: IconProps): React.ReactElement {
  return <PhosphorTrashIcon size={20} weight="regular" {...props} />;
}
